export default __webpack_public_path__ + "static/media/No.5-0.267a4214.jpg";